/* eslint-disable import/no-cycle */
import * as occlTemplates from './occl';
import * as tefOneTemplates from './tefOne';

export type TemplatesType = typeof tefOneTemplates;

export const templates = {
  occl: occlTemplates as unknown as TemplatesType,
  tefOne: tefOneTemplates,
};
